import { render, staticRenderFns } from "./WikiSelect.vue?vue&type=template&id=180f91a3&"
import script from "./WikiSelect.vue?vue&type=script&lang=js&"
export * from "./WikiSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports